<div class="dropdown dropdown-inline" [matTooltip]="progressOption.label">
  <a
    class="btn font-weight-bolder btn-sm"
    [ngClass]="progressOption.color"
    [class.active]="progressOption === activeFilter"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    {{ progressOption.label }}
  </a>
  <div
    class="dropdown-menu dropdown-menu-sm dropdown-menu-right"
    style="
      position: absolute;
      will-change: transform;
      top: 0;
      left: 0;
      transform: translate3d(-92px, 33px, 0px);
    "
    x-placement="bottom-end"
  >
    <!--begin::Navigation-->
    <ul class="navi navi-hover">
      <div *ngFor="let priorityOption of priorityOptions">
        <li class="navi-item">
          <a class="navi-link" (click)="onActionClick(priorityOption.value)">
            <span class="navi-text"> {{ priorityOption.label }} </span>
          </a>
        </li>
      </div>
    </ul>
    <!--end::Navigation-->
  </div>
</div>
